// EC Pedal Works - Premium Bike Accessories & Cycling Gear
// Brand: EC Pedal Works
// Corporate: EC CAPITAL INVESTMENTS LLC
// Inspired by onlinesuppliesforbikes.com (bike accessories marketplace)

// ============================================
// SITE IMAGES - Cycling / Bike Theme
// ============================================
export const siteImages = {
  heroMain: 'https://images.unsplash.com/photo-1678026038177-74330c556d20?q=80&w=2574&auto=format&fit=crop',
  heroSecondary: 'https://images.unsplash.com/photo-1591429803306-431bbc42fe29?q=80&w=2672&auto=format&fit=crop',
  heroLifestyle: 'https://images.unsplash.com/photo-1485965120184-e220f721d03e?q=80&w=2670&auto=format&fit=crop',
  ctaBackground: 'https://images.unsplash.com/photo-1517649763962-0c623066013b?q=80&w=2670&auto=format&fit=crop',
  featuredBackground: 'https://images.unsplash.com/photo-1571068316344-75bc76f77890?q=80&w=2670&auto=format&fit=crop',
  powerBackground: 'https://images.unsplash.com/photo-1502744688674-c619d1586c9e?q=80&w=2670&auto=format&fit=crop',
  shopBanner: 'https://images.unsplash.com/photo-1517649763962-0c623066013b?q=80&w=2670&auto=format&fit=crop',
  aboutBanner: 'https://images.unsplash.com/photo-1485965120184-e220f721d03e?q=80&w=2670&auto=format&fit=crop',
  contactBanner: 'https://images.unsplash.com/photo-1517649763962-0c623066013b?q=80&w=2670&auto=format&fit=crop',
  returnsBanner: 'https://images.unsplash.com/photo-1493225457124-a3eb161ffa5f?q=80&w=2670&auto=format&fit=crop',
  privacyBanner: 'https://images.unsplash.com/photo-1571068316344-75bc76f77890?q=80&w=2670&auto=format&fit=crop',
};

export const SHIPPING_NOTICE = 'We ship within the USA via USPS';
export const SHIPPING_COUNTRIES = ['US'];
export const SHIPPING_METHOD = 'USPS';
export const SHIPPING_TIME = '2-4 business days';
export const FREE_SHIPPING_THRESHOLD = 0; // Free shipping on all orders

export const CARD_DESCRIPTOR = '8336980799ecpedalworks';
export const HOSTING_PROVIDER = 'Hostinger';

export const CONTACT_INFO = {
  phone: '(833) 698-0799',
  email: 'contactus@ecpedalworks.com',
  corpName: 'EC CAPITAL INVESTMENTS LLC',
  address: {
    street: '2212 N Sibley St',
    city: 'Metairie',
    state: 'LA',
    zip: '70003',
    country: 'United States'
  }
};

export const RETURN_ADDRESS = {
  street: '4711 34th St. N.',
  suite: 'Suite F',
  city: 'St. Petersburg',
  state: 'FL',
  zip: '33714',
  country: 'USA'
};

// ============================================
// BIKE PRODUCT CATALOG
// ============================================
// Specific prices applied to nearest products:
// $9.63, $12.84, $19.26, $19.37, $28.89, $58.11, $77.48,
// $142.16, $227.48, $318.72, $489.36, $612.44, $784.88, $999.00

export const products = [
  // ===== SAFETY & VISIBILITY =====
  {
    id: "bike-multi-tool",
    name: "Bike Multi-Tool",
    slug: "bike-multi-tool",
    sku: "EC-PED-001",
    price: 9.63,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HT0J638RATYEPCHB52HZBP6Y.avif",
    badge: "Deal",
    categoryId: "pumps-tools-repair",
    categorySlug: "pumps-tools-repair",
    description: "A compact and lightweight multi-tool that fits in your pocket or saddle bag. Includes hex keys, screwdrivers, and a chain breaker for trailside repairs.",
    keyBenefits: ["Pocket-sized for any ride", "Includes all essential bike tools", "Durable steel construction"],
    usage: "Carry on every ride for quick on-the-go adjustments and emergency repairs.",
    features: ["Hex Keys", "Chain Breaker", "Screwdrivers", "Compact"],
    inStock: true
  },
  {
    id: "led-bike-wheel-lights",
    name: "LED Bike Wheel Lights",
    slug: "led-bike-wheel-lights",
    sku: "EC-PED-002",
    price: 12.84,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HT0HKC4VJ0D5EA3S10292DM2.avif",
    badge: "Best Seller",
    categoryId: "safety-visibility",
    categorySlug: "safety-visibility",
    description: "These LED bike wheel lights are designed to enhance visibility and add a stylish glow to your bicycle. Easy installation on any spoke for instant night-time safety.",
    keyBenefits: ["360-degree visibility", "Long-lasting battery", "Multiple color modes"],
    usage: "Attach to spokes for nighttime rides, urban commuting, or evening group rides.",
    features: ["LED Glow", "Battery Powered", "Easy Install", "Weatherproof"],
    inStock: true
  },
  {
    id: "1-pair-bicycle-rear-view-mirror",
    name: "1 Pair Bicycle Rear View Mirror",
    slug: "1-pair-bicycle-rear-view-mirror",
    sku: "EC-PED-003",
    price: 19.26,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HTDKH0DFTZT5MTJKCM8D97FX.jpg",
    badge: "Safety",
    categoryId: "safety-visibility",
    categorySlug: "safety-visibility",
    description: "A pair of bicycle mirrors designed for enhanced rider safety. Wide-angle lenses give you a clear view of traffic behind you so you can ride confidently.",
    keyBenefits: ["Wide-angle visibility", "Adjustable mounting", "Shatter-resistant lens"],
    usage: "Mount on handlebars for clear rear vision during urban commutes and group rides.",
    features: ["Pair Set", "Wide Angle", "Adjustable", "Universal Fit"],
    inStock: true
  },
  {
    id: "water-bottle-holder",
    name: "Water Bottle Holder",
    slug: "water-bottle-holder",
    sku: "EC-PED-004",
    price: 19.37,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HT0JEK6Z8PS7XZTSDHEB1781.avif",
    badge: "Essential",
    categoryId: "storage-hydration",
    categorySlug: "storage-hydration",
    description: "This water bottle holder is designed to securely hold your water bottle while you ride. Lightweight, durable, and easy to install on any standard bike frame.",
    keyBenefits: ["Holds standard bottles securely", "Lightweight aluminum", "Bolts onto any frame"],
    usage: "Mount on bike frame for hydration during long rides, training, and commuting.",
    features: ["Aluminum", "Secure Grip", "Universal", "Lightweight"],
    inStock: true
  },
  {
    id: "mini-bicycle-pump",
    name: "Mini Bicycle Pump",
    slug: "mini-bicycle-pump",
    sku: "EC-PED-005",
    price: 28.89,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HT0J1X197044FA118QJFC3C7.avif",
    badge: "Compact",
    categoryId: "pumps-tools-repair",
    categorySlug: "pumps-tools-repair",
    description: "This mini bicycle pump is a compact and lightweight solution for inflating your tires on the go. Compatible with both Presta and Schrader valves for universal use.",
    keyBenefits: ["Dual-valve compatibility", "Frame-mountable", "High-pressure capable"],
    usage: "Carry on rides for quick tire inflation. Great for road, mountain, and commuter bikes.",
    features: ["Dual Valve", "Frame Mount", "High Pressure", "Compact"],
    inStock: true
  },
  {
    id: "rechargeable-air-pump",
    name: "Rechargeable Air Pump",
    slug: "rechargeable-air-pump",
    sku: "EC-PED-006",
    price: 58.11,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HS1PB4XZ775CF7R1B9K5F68H.webp",
    badge: "Wireless",
    categoryId: "pumps-tools-repair",
    categorySlug: "pumps-tools-repair",
    description: "Experience the freedom of portability with our compact and wireless rechargeable air pump. Inflate tires, balls, and inflatables with the press of a button.",
    keyBenefits: ["Cordless rechargeable design", "Digital pressure preset", "Multi-purpose use"],
    usage: "Use for bike tires, car tires, sports balls and inflatables. Charges via USB-C.",
    features: ["Rechargeable", "Digital Display", "USB-C", "Multi-Use"],
    inStock: true
  },
  {
    id: "fingerless-sports-gloves-for-cycling",
    name: "Fingerless Sports Gloves for Cycling",
    slug: "fingerless-sports-gloves-for-cycling",
    sku: "EC-PED-007",
    price: 58.11,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HTFXFNENCTKEDWSG0DY9NES7.jpg",
    badge: "Comfort",
    categoryId: "riding-gear",
    categorySlug: "riding-gear",
    description: "Maintain a firm, comfortable grip on every ride with these ventilated fingerless cycling gloves. Padded palms reduce hand fatigue on long rides.",
    keyBenefits: ["Padded palm protection", "Breathable mesh top", "Anti-slip grip"],
    usage: "Wear for road cycling, mountain biking, spinning class and long-distance touring.",
    features: ["Padded Palm", "Breathable", "Anti-Slip", "Fingerless"],
    inStock: true
  },
  {
    id: "bike-handlebar-bottle-holders",
    name: "Bike Handlebar Bottle Holders",
    slug: "bike-handlebar-bottle-holders",
    sku: "EC-PED-008",
    price: 58.11,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HV7594V2S4TYCMYEG56HH8BK.jpg",
    badge: "Dual Pack",
    categoryId: "storage-hydration",
    categorySlug: "storage-hydration",
    description: "Gear up for long rides with our Dual Bike Handlebar Bottle Holders, the ultimate way to carry two bottles within easy reach without crowding your frame.",
    keyBenefits: ["Holds two bottles at once", "Quick-release straps", "Handlebar-mounted"],
    usage: "Mount on handlebars for ultra-long-distance touring, gravel rides and hot-day commutes.",
    features: ["Dual Bottles", "Handlebar Mount", "Quick Release", "Adjustable"],
    inStock: true
  },
  {
    id: "bluetooth-bike-speaker",
    name: "Bluetooth Bike Speaker",
    slug: "bluetooth-bike-speaker",
    sku: "EC-PED-009",
    price: 77.48,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HT0JX3KXRJ21VJ8KACFW113G.avif",
    badge: "Smart",
    categoryId: "tech-electronics",
    categorySlug: "tech-electronics",
    description: "Bring your playlist along for the ride with this weather-resistant Bluetooth speaker. Crystal clear audio and powerful bass for outdoor adventures.",
    keyBenefits: ["IPX5 water-resistant", "Long battery life", "Handlebar mountable"],
    usage: "Stream music, podcasts and GPS instructions during commutes, trail rides and group rides.",
    features: ["Bluetooth 5.0", "Waterproof", "Long Battery", "Handlebar Mount"],
    inStock: true
  },
  {
    id: "bicycle-rear-derailleur-set",
    name: "Bicycle Rear Derailleur Set",
    slug: "bicycle-rear-derailleur-set",
    sku: "EC-PED-010",
    price: 77.48,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HV9HB2M7GZBR2R7PM9X8C6HY.jpg",
    badge: "Drivetrain",
    categoryId: "bikes-components",
    categorySlug: "bikes-components",
    description: "Restore crisp, reliable shifting to your drivetrain with this complete rear derailleur set. Engineered for smooth gear transitions on any terrain.",
    keyBenefits: ["Smooth precise shifting", "Durable steel cage", "Multi-speed compatible"],
    usage: "Upgrade or replace your existing derailleur for crisp shifting on road and mountain bikes.",
    features: ["Steel Cage", "Multi-Speed", "Precise Shifts", "Pro Grade"],
    inStock: true
  },
  {
    id: "child-bike-seat",
    name: "Child Bike Seat",
    slug: "child-bike-seat",
    sku: "EC-PED-011",
    price: 77.48,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HV9EQMGJHSNG6V6FSAYBWPPS.jpg",
    badge: "Family",
    categoryId: "riding-gear",
    categorySlug: "riding-gear",
    description: "Introduce your little one to the joy of cycling with the Comfort Cruiser Child Bike Seat. Padded seat and 5-point harness keep your child safe on every ride.",
    keyBenefits: ["5-point safety harness", "Padded ergonomic seat", "Foot rests with straps"],
    usage: "Secure your child for around-the-neighborhood rides, errands, and family adventures.",
    features: ["5-Point Harness", "Padded", "Foot Rests", "Easy Install"],
    inStock: true
  },
  {
    id: "wireless-bike-computer",
    name: "Wireless Bike Computer",
    slug: "wireless-bike-computer",
    sku: "EC-PED-012",
    price: 77.48,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HT0JQNNK3YR2XGYEJYAMF0A9.avif",
    badge: "Tech",
    categoryId: "tech-electronics",
    categorySlug: "tech-electronics",
    description: "Track every metric that matters with this wireless cycling computer. A clean backlit display shows speed, distance, time, and calories burned at a glance.",
    keyBenefits: ["Wireless data display", "Backlit LCD screen", "Multiple ride metrics"],
    usage: "Mount on handlebars to monitor speed, distance, time and trip data during every ride.",
    features: ["Wireless", "Backlit LCD", "Speedometer", "Odometer"],
    inStock: true
  },
  {
    id: "bike-performance-accessory",
    name: "Bike Performance Accessory",
    slug: "bike-performance-accessory",
    sku: "EC-PED-013",
    price: 77.48,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HYBMT6F9MWS9K6WVTT1MWRTY.jpg",
    badge: "Upgrade",
    categoryId: "bikes-components",
    categorySlug: "bikes-components",
    description: "Boost your ride's performance with this premium accessory. Engineered for cyclists who want to upgrade speed, comfort and overall cycling experience.",
    keyBenefits: ["Aerospace-grade aluminum", "Lightweight design", "Performance-boosting"],
    usage: "Install on your bike for a noticeable upgrade in performance, comfort and speed.",
    features: ["Aluminum", "Lightweight", "Performance", "Universal"],
    inStock: true
  },
  {
    id: "high-performance-carbon-fiber-ceramic-rear-pulleys",
    name: "High-Performance Carbon Fiber Ceramic Rear Pulleys",
    slug: "high-performance-carbon-fiber-ceramic-rear-pulleys",
    sku: "EC-PED-014",
    price: 77.48,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HYBP80686DZS1ZARS7H8T36T.jpg",
    badge: "Pro",
    categoryId: "bikes-components",
    categorySlug: "bikes-components",
    description: "Reduce drivetrain friction and squeeze extra watts from every pedal stroke with these ceramic-bearing carbon fiber jockey wheels. A direct upgrade for riders chasing marginal gains.",
    keyBenefits: ["Ceramic bearings reduce drag", "Carbon fiber construction", "Watt savings on climbs"],
    usage: "Swap your stock pulleys for marginal gains on climbs, time trials and competitive racing.",
    features: ["Carbon Fiber", "Ceramic Bearings", "Pro Grade", "Lightweight"],
    inStock: true
  },
  {
    id: "bike-rearview-camera",
    name: "Bike Rearview Camera",
    slug: "bike-rearview-camera",
    sku: "EC-PED-015",
    price: 77.48,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HT0K2JNHA92X9GDRFYRV27N3.avif",
    badge: "Innovative",
    categoryId: "safety-visibility",
    categorySlug: "safety-visibility",
    description: "An innovative safety device designed to enhance visibility behind you. Wireless transmission to your bike computer or smartphone keeps your eyes on the road.",
    keyBenefits: ["Live rear-view monitoring", "Wireless connectivity", "Weather-resistant build"],
    usage: "Mount on seatpost for live rear traffic awareness during urban commutes and group rides.",
    features: ["Wireless", "Live Feed", "Weatherproof", "Long Battery"],
    inStock: true
  },
  {
    id: "wall-mounted-bike-repair-stand-with-adjustable-clamp",
    name: "Wall-Mounted Bike Repair Stand with Adjustable Clamp",
    slug: "wall-mounted-bike-repair-stand-with-adjustable-clamp",
    sku: "EC-PED-016",
    price: 77.48,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HYBKN670GT3FTXV53KS4Z3Y1.jpg",
    badge: "Workshop",
    categoryId: "pumps-tools-repair",
    categorySlug: "pumps-tools-repair",
    description: "Turn any garage wall into a dedicated bike workshop with this fold-flat repair stand. Adjustable clamp securely holds frames for cleaning, tuning and overhauls.",
    keyBenefits: ["Fold-flat space saver", "360-degree clamp rotation", "Holds frames up to 55lbs"],
    usage: "Mount on garage or shop wall to perform full bike tune-ups, brake bleeds and drivetrain cleaning.",
    features: ["Wall Mount", "Fold-Flat", "360° Rotation", "Heavy Duty"],
    inStock: true
  },
  {
    id: "bicycle-lock-with-alarm",
    name: "Bicycle Lock with Alarm",
    slug: "bicycle-lock-with-alarm",
    sku: "EC-PED-017",
    price: 77.48,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HT0K7XVB172RQVR01J6MZ657.avif",
    badge: "Security",
    categoryId: "safety-visibility",
    categorySlug: "safety-visibility",
    description: "Deter thieves with both physical resistance and a piercing 110dB alarm built right into the lock. Vibration sensor triggers loud alarm at the slightest tamper.",
    keyBenefits: ["110dB anti-theft alarm", "Hardened steel cable", "Vibration sensor"],
    usage: "Lock to bike racks at work, gym, transit hubs, and city streets for maximum theft protection.",
    features: ["110dB Alarm", "Hardened Steel", "Vibration Sensor", "Weatherproof"],
    inStock: true
  },
  {
    id: "urban-chic-front-bike-basket-with-wooden-slats",
    name: "Urban Chic Front Bike Basket with Wooden Slats",
    slug: "urban-chic-front-bike-basket-with-wooden-slats",
    sku: "EC-PED-018",
    price: 142.16,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HYBMCHYQ0E1JN1N1RX82VG9Z.jpg",
    badge: "Stylish",
    categoryId: "storage-hydration",
    categorySlug: "storage-hydration",
    description: "Enhance the functionality and style of your bicycle with our Urban Chic Front Bike Basket. Hand-finished wooden slats and metal frame for vintage city style.",
    keyBenefits: ["Vintage wooden-slat design", "Sturdy metal frame", "Quick-release mount"],
    usage: "Carry groceries, books, gear and tote bags during city commutes and errands.",
    features: ["Wooden Slats", "Metal Frame", "Quick Release", "Vintage Style"],
    inStock: true
  },
  {
    id: "adjustable-horizontal-bicycle-wall-mount-rack",
    name: "Adjustable Horizontal Bicycle Wall Mount Rack",
    slug: "adjustable-horizontal-bicycle-wall-mount-rack",
    sku: "EC-PED-019",
    price: 142.16,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HYBJS6ATBGH1BGR4NPBSZS4B.jpg",
    badge: "Storage",
    categoryId: "racks-mounts",
    categorySlug: "racks-mounts",
    description: "Maximize your space and keep your bike secure with our Adjustable Horizontal Bicycle Wall Mount Rack. Padded cradles protect your frame from scratches.",
    keyBenefits: ["Space-saving horizontal mount", "Padded frame protection", "Adjustable for any bike"],
    usage: "Mount on garage, apartment or shop walls for stylish, space-saving bike storage.",
    features: ["Wall Mount", "Padded Cradles", "Adjustable", "Heavy Duty"],
    inStock: true
  },
  {
    id: "lockable-hitch-mount-bike-rack-for-suv-truck",
    name: "Lockable Hitch Mount Bike Rack for SUV & Truck",
    slug: "lockable-hitch-mount-bike-rack-for-suv-truck",
    sku: "EC-PED-020",
    price: 142.16,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HYBMEMGHJ2KPH7CYFHTGGRF2.jpg",
    badge: "Travel",
    categoryId: "racks-mounts",
    categorySlug: "racks-mounts",
    description: "Enhance your outdoor adventures with our Lockable Hitch Mount Bike Rack, a sturdy carrier for SUVs and trucks. Built-in locks deter theft on the road.",
    keyBenefits: ["Holds up to 4 bikes", "Anti-sway cradles", "Integrated cable lock"],
    usage: "Hitch-mount for road trips, mountain bike outings, family adventures and race days.",
    features: ["4-Bike Capacity", "Lockable", "Anti-Sway", "Heavy Duty"],
    inStock: true
  },
  {
    id: "teen-bicycle",
    name: "Teen Bicycle",
    slug: "teen-bicycle",
    sku: "EC-PED-021",
    price: 227.48,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HTDQ9TVZ96TA40H334A35NZR.jpg",
    badge: "Youth",
    categoryId: "bikes-components",
    categorySlug: "bikes-components",
    description: "A classic teen bicycle showcasing a robust and sleek design in a vibrant finish. Lightweight frame and reliable components for everyday riding.",
    keyBenefits: ["Lightweight teen-sized frame", "Multi-speed drivetrain", "Comfortable saddle"],
    usage: "Daily school commutes, weekend rides, neighborhood adventures and park trips.",
    features: ["Lightweight Frame", "Multi-Speed", "Comfort Saddle", "Hand Brakes"],
    inStock: true
  },
  {
    id: "smart-helmet",
    name: "Smart Helmet",
    slug: "smart-helmet",
    sku: "EC-PED-022",
    price: 227.48,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HT0KXJKN0YBRXRD4FY53JHNW.avif",
    badge: "Smart",
    categoryId: "safety-visibility",
    categorySlug: "safety-visibility",
    description: "An advanced safety accessory designed to provide cyclists with integrated lighting, turn signals and crash detection. Stay seen and stay connected.",
    keyBenefits: ["Built-in LED turn signals", "Crash detection alerts", "Bluetooth connectivity"],
    usage: "Wear during urban commutes and group rides for maximum visibility and emergency safety.",
    features: ["LED Signals", "Crash Detect", "Bluetooth", "USB Rechargeable"],
    inStock: true
  },
  {
    id: "electric-bike-conversion-kit",
    name: "Electric Bike Conversion Kit",
    slug: "electric-bike-conversion-kit",
    sku: "EC-PED-023",
    price: 318.72,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HT0KQR2M2X29KCMT87VR69YD.webp",
    badge: "E-Bike",
    categoryId: "tech-electronics",
    categorySlug: "tech-electronics",
    description: "Transform your standard bicycle into a powerful e-bike. This conversion kit includes motor, battery, controller and display — everything you need to electrify your ride.",
    keyBenefits: ["Complete e-bike conversion", "Long-range lithium battery", "Pedal-assist & throttle modes"],
    usage: "Install on your existing bike to enable assisted cycling for longer commutes and effortless hill climbs.",
    features: ["Motor", "Battery", "Display", "Pedal Assist"],
    inStock: true
  },
  {
    id: "kids-bike-with-aerospace-aluminum-frame",
    name: "Kids Bike with Aerospace Aluminum Frame",
    slug: "kids-bike-with-aerospace-aluminum-frame",
    sku: "EC-PED-024",
    price: 318.72,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HYBMT6F9MWS9K6WVTT1MWRTY.jpg",
    badge: "Kids",
    categoryId: "bikes-components",
    categorySlug: "bikes-components",
    description: "Introduce your child to the joys of cycling with our kids' bike, crafted from lightweight aerospace aluminum. Easy handling, comfortable geometry and durable build.",
    keyBenefits: ["Ultra-lightweight aluminum", "Adjustable seat & handlebars", "Training wheels included"],
    usage: "Perfect first bike for kids learning to ride. Built tough for years of neighborhood adventures.",
    features: ["Aerospace Aluminum", "Adjustable", "Training Wheels", "Hand Brakes"],
    inStock: true
  },
  {
    id: "premium-mountain-bike",
    name: "Premium Mountain Bike",
    slug: "premium-mountain-bike",
    sku: "EC-PED-025",
    price: 489.36,
    image: "https://images.unsplash.com/photo-1576435728678-68d0fbf94e91?q=80&w=1200&auto=format&fit=crop",
    badge: "Trail Ready",
    categoryId: "bikes-components",
    categorySlug: "bikes-components",
    description: "Conquer any trail with our Premium Mountain Bike. Front suspension fork, hydraulic disc brakes and 21-speed drivetrain deliver confident off-road performance.",
    keyBenefits: ["Front suspension fork", "Hydraulic disc brakes", "21-speed drivetrain"],
    usage: "Tackle singletrack, fire roads, rocky descents and weekend trail rides with confidence.",
    features: ["Suspension Fork", "Disc Brakes", "21-Speed", "Aluminum Frame"],
    inStock: true
  },
  {
    id: "pro-carbon-road-bike",
    name: "Pro Carbon Road Bike",
    slug: "pro-carbon-road-bike",
    sku: "EC-PED-026",
    price: 612.44,
    image: "https://images.unsplash.com/photo-1532298229144-0ec0c57515c7?q=80&w=1200&auto=format&fit=crop",
    badge: "Pro Road",
    categoryId: "bikes-components",
    categorySlug: "bikes-components",
    description: "Experience the responsiveness of a true racing machine. Carbon fiber frame, aero geometry and precision drivetrain deliver speed for serious road cyclists.",
    keyBenefits: ["Lightweight carbon frame", "Aero road geometry", "Precision shifting"],
    usage: "Long road rides, club rides, century events and competitive road racing.",
    features: ["Carbon Frame", "Aero Geometry", "Drop Bars", "Pro Drivetrain"],
    inStock: true
  },
  {
    id: "adult-electric-bicycle",
    name: "Adult Electric Bicycle (E-Bike)",
    slug: "adult-electric-bicycle",
    sku: "EC-PED-027",
    price: 784.88,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HT0KQR2M2X29KCMT87VR69YD.webp",
    badge: "Electric",
    categoryId: "tech-electronics",
    categorySlug: "tech-electronics",
    description: "Glide through your commute effortlessly with our Adult Electric Bicycle. Powerful hub motor, removable lithium battery and 50+ mile range transform your daily ride.",
    keyBenefits: ["50+ mile range per charge", "Removable lithium battery", "Pedal-assist & throttle"],
    usage: "Daily commuting, errands, weekend cruising and effortless long-distance touring.",
    features: ["Hub Motor", "50+ Mile Range", "Removable Battery", "LCD Display"],
    inStock: true
  },
  {
    id: "elite-carbon-fiber-race-bike",
    name: "Elite Carbon Fiber Race Bike",
    slug: "elite-carbon-fiber-race-bike",
    sku: "EC-PED-028",
    price: 999.00,
    image: "https://images.unsplash.com/photo-1485965120184-e220f721d03e?q=80&w=1200&auto=format&fit=crop",
    badge: "Flagship",
    categoryId: "bikes-components",
    categorySlug: "bikes-components",
    description: "Our flagship racing machine. Full carbon monocoque frame, electronic shifting, aero wheelset and uncompromising performance designed for serious racers.",
    keyBenefits: ["Full carbon monocoque frame", "Electronic groupset", "Aero carbon wheelset"],
    usage: "Competitive road racing, gran fondos, time trials and ultra-elite training programs.",
    features: ["Carbon Monocoque", "Electronic Shifting", "Aero Wheels", "Pro Geometry"],
    inStock: true
  },
  // ===== EXTENDED CATALOG — MID PRICE POINTS =====
  {
    id: "muc-off-bike-cleaner-1l",
    name: "Muc-Off Bike Cleaner 1L",
    slug: "muc-off-bike-cleaner-1l",
    sku: "EC-PED-029",
    price: 13.99,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HS1PB4XZ775CF7R1B9K5F68H.webp",
    badge: "Best Value",
    categoryId: "lubricants-care",
    categorySlug: "lubricants-care",
    description: "The Muc-Off Bike Cleaner is a fast-acting, biodegradable formula that lifts dirt, mud and road grime from every surface of your bike. Safe on carbon, paint and anodized parts.",
    keyBenefits: ["Biodegradable Nano Tech formula", "Safe on all bike surfaces", "Lifts even dried-on mud"],
    usage: "Spray on dry bike, leave 3-5 minutes, rinse off with water. Use weekly after rides.",
    features: ["Biodegradable", "1L Spray", "Safe On Carbon", "Quick Action"],
    inStock: true
  },
  {
    id: "sks-speedrocker-mudguard-set",
    name: "SKS Speedrocker Mudguard Set",
    slug: "sks-speedrocker-mudguard-set",
    sku: "EC-PED-030",
    price: 33.00,
    image: "https://images.unsplash.com/photo-1571188654248-7a89213915f7?q=80&w=1200&auto=format&fit=crop",
    badge: "Gravel",
    categoryId: "bikes-components",
    categorySlug: "bikes-components",
    description: "The SKS Speedrocker Mudguard Set is a lightweight, tool-free fender solution engineered specifically for gravel and cyclocross bikes. Keeps spray off your back and frame.",
    keyBenefits: ["Tool-free quick attachment", "Designed for gravel/CX bikes", "Lightweight ABS construction"],
    usage: "Clip onto seatpost and fork for wet rides, gravel tours and muddy commutes.",
    features: ["Tool-Free", "Gravel Specific", "Front & Rear Set", "Lightweight"],
    inStock: true
  },
  {
    id: "silca-secret-chain-blend-hot-wax-500g",
    name: "Silca Secret Chain Blend Hot Wax 500g",
    slug: "silca-secret-chain-blend-hot-wax-500g",
    sku: "EC-PED-031",
    price: 39.00,
    image: "https://www.bike-discount.de/media/f4/a9/3e/1705525263/silca-secret-chain-blend-hot-wax-kettenwachs-500g-am-ac-016-asy-0100.jpg",
    badge: "Pro Wax",
    categoryId: "lubricants-care",
    categorySlug: "lubricants-care",
    description: "Silca's Secret Chain Blend is the World Tour proven hot-melt wax used by professional teams. Saves up to 6 watts versus standard chain lubes and protects against drivetrain wear.",
    keyBenefits: ["World Tour proven formula", "Up to 6 watts saved", "Extended chain life"],
    usage: "Melt in dedicated wax pot, dip a stripped chain, hang to dry. One coat lasts 300+ km.",
    features: ["Hot Melt Wax", "Pro Formula", "500g Block", "Watt Saving"],
    inStock: true
  },
  {
    id: "cube-hpp-bottle-cage-pair",
    name: "Cube HPP Bottle Cage — Pair",
    slug: "cube-hpp-bottle-cage-pair",
    sku: "EC-PED-032",
    price: 43.00,
    image: "https://images.unsplash.com/photo-1532187863486-abf9dbad1b69?q=80&w=1200&auto=format&fit=crop",
    badge: "Twin Pack",
    categoryId: "storage-hydration",
    categorySlug: "storage-hydration",
    description: "Cube's HPP bottle cages are injection-molded high-performance polymer, delivering a perfect grip on any standard bottle while staying virtually weightless. Set of two.",
    keyBenefits: ["Flex-tuned secure grip", "Reinforced HPP polymer", "Lightweight 32g per cage"],
    usage: "Bolt onto down tube and seat tube to carry two bottles on long road, gravel and MTB rides.",
    features: ["HPP Polymer", "Twin Pack", "Universal Fit", "Lightweight"],
    inStock: true
  },
  {
    id: "bosch-smartphone-grip-mount",
    name: "Bosch SmartphoneGrip Mobile Phone Holder",
    slug: "bosch-smartphone-grip-mount",
    sku: "EC-PED-033",
    price: 44.00,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HT0JX3KXRJ21VJ8KACFW113G.avif",
    badge: "Smart System",
    categoryId: "tech-electronics",
    categorySlug: "tech-electronics",
    description: "Turn your phone into a full bike display with the Bosch SmartphoneGrip. Integrates with the Bosch eBike Flow app for navigation, ride data and connected features.",
    keyBenefits: ["Bosch Smart System ready", "Secure handlebar mount", "Universal phone fit"],
    usage: "Mount on handlebar/stem to navigate, log rides and view e-bike data on your phone.",
    features: ["Smart System", "Universal Fit", "Secure Lock", "Quick Release"],
    inStock: true
  },
  {
    id: "voxom-epu2-battery-pump",
    name: "Voxom EPu2 Battery Pump",
    slug: "voxom-epu2-battery-pump",
    sku: "EC-PED-034",
    price: 48.75,
    image: "https://www.bike-discount.de/media/8b/40/25/1760909975/voxom-elektrische-pumpe-epu2-schwarzy6o57bqxqjmgt.jpg",
    badge: "Cordless",
    categoryId: "pumps-tools-repair",
    categorySlug: "pumps-tools-repair",
    description: "The Voxom EPu2 is a pocket-sized electric inflator that delivers up to 120 PSI on demand. Digital preset, USB-C charging and Presta/Schrader compatibility built-in.",
    keyBenefits: ["120 PSI digital preset", "USB-C rechargeable", "Pocket form factor"],
    usage: "Carry on rides for trail-side inflation. Also works for car tires, sports balls and inflatables.",
    features: ["120 PSI", "USB-C", "Digital Display", "Dual Valve"],
    inStock: true
  },
  {
    id: "radon-torque-wrench-25-piece-set",
    name: "Radon Comp Torque Wrench 2-24 Nm + 25-Piece Bit Set",
    slug: "radon-torque-wrench-25-piece-set",
    sku: "EC-PED-035",
    price: 49.00,
    image: "https://www.bike-discount.de/media/6b/1d/00/1705242897/95486.jpg",
    badge: "Workshop",
    categoryId: "pumps-tools-repair",
    categorySlug: "pumps-tools-repair",
    description: "A precision 1/4\" click-style torque wrench covering 2-24 Nm with a 25-piece bit selection. Everything you need to safely tighten carbon parts, stems and cockpit bolts.",
    keyBenefits: ["Precision click engagement", "2-24 Nm range", "25 bits included"],
    usage: "Use for installing stems, seatposts, handlebars, brake levers and carbon components.",
    features: ["2-24 Nm", "25 Bits", "Click Style", "Hard Case"],
    inStock: true
  },
  {
    id: "acid-fm-kickstand",
    name: "ACID FM Adjustable Kickstand",
    slug: "acid-fm-kickstand",
    sku: "EC-PED-036",
    price: 50.00,
    image: "https://images.unsplash.com/photo-1532298229144-0ec0c57515c7?q=80&w=1200&auto=format&fit=crop",
    badge: "Daily",
    categoryId: "bikes-components",
    categorySlug: "bikes-components",
    description: "ACID's FM kickstand mounts on the chainstay and adjusts in length to fit 26\" through 29\" wheels. Aluminum body keeps weight low while supporting loaded touring bikes.",
    keyBenefits: ["Fits 26\"–29\" wheels", "Length-adjustable", "Aluminum lightweight build"],
    usage: "Bolt onto chainstay mount for stable parking on touring, trekking and urban bikes.",
    features: ["Aluminum", "Adjustable", "Universal", "Chainstay Mount"],
    inStock: true
  },
  {
    id: "magura-royal-blood-mineral-oil-1l",
    name: "Magura Royal Blood Hydraulic Oil 1L",
    slug: "magura-royal-blood-mineral-oil-1l",
    sku: "EC-PED-037",
    price: 55.00,
    image: "https://www.bike-discount.de/media/96/35/cb/1705519654/squirt-lube-kettenwachs-sl120.jpg",
    badge: "OEM Spec",
    categoryId: "lubricants-care",
    categorySlug: "lubricants-care",
    description: "Genuine Magura Royal Blood mineral oil — the only fluid approved for Magura hydraulic brakes. The 1L bulk bottle is perfect for shops and home mechanics.",
    keyBenefits: ["OEM Magura formula", "1L workshop bottle", "Stable to 280°C"],
    usage: "Use exclusively for bleeding Magura hydraulic disc and rim brakes. Never substitute DOT fluid.",
    features: ["Mineral Oil", "1L Bottle", "OEM Magura", "High Temp"],
    inStock: true
  },
  {
    id: "hebie-alumee-mudguard-set-28",
    name: "Hebie ALUMEE Mudguard Set 28\"",
    slug: "hebie-alumee-mudguard-set-28",
    sku: "EC-PED-038",
    price: 56.25,
    image: "https://images.unsplash.com/photo-1593764592116-bfb2a97c642a?q=80&w=1200&auto=format&fit=crop",
    badge: "Touring",
    categoryId: "bikes-components",
    categorySlug: "bikes-components",
    description: "Hebie's aluminum-bodied ALUMEE fenders give your trekking or city bike all-weather coverage with a polished metallic finish. Includes stainless stays and pre-shaped struts.",
    keyBenefits: ["Aluminum body", "Stainless stays", "All-weather coverage"],
    usage: "Bolt to braze-ons for daily commuting, trekking tours and four-season city riding.",
    features: ["Aluminum", "28\" Wheels", "Stainless Stays", "Pre-Shaped"],
    inStock: true
  },
  {
    id: "dynamic-turblo-battery-pump",
    name: "Dynamic Turblo Battery Pump",
    slug: "dynamic-turblo-battery-pump",
    sku: "EC-PED-039",
    price: 57.00,
    image: "https://www.bike-discount.de/media/8b/40/25/1760909975/voxom-elektrische-pumpe-epu2-schwarzy6o57bqxqjmgt.jpg",
    badge: "Wireless",
    categoryId: "pumps-tools-repair",
    categorySlug: "pumps-tools-repair",
    description: "Dynamic Bike Care's Turblo is a cordless pump with a clear OLED display, 100 PSI capability and a swappable lithium battery. Great backup for the home garage or race pit.",
    keyBenefits: ["OLED pressure display", "Swappable battery", "100 PSI max"],
    usage: "Use as a home and travel pump for road, MTB, gravel, e-bike and car-tire inflation.",
    features: ["OLED", "Swappable Battery", "100 PSI", "Cordless"],
    inStock: true
  },
  {
    id: "stans-tire-sealant-1l",
    name: "Stan's NoTubes Tire Sealant 1L",
    slug: "stans-tire-sealant-1l",
    sku: "EC-PED-040",
    price: 58.00,
    image: "https://www.bike-discount.de/media/d7/04/bd/1724403286/st0157-tire-sealant-reifendichtmittel-master.jpg",
    badge: "Tubeless",
    categoryId: "lubricants-care",
    categorySlug: "lubricants-care",
    description: "Stan's industry-defining tubeless tire sealant in the 1L workshop bottle. Seals punctures up to 6.5mm instantly and stays liquid in temperatures from -25°F to 130°F.",
    keyBenefits: ["Seals punctures up to 6.5mm", "1L workshop bottle", "Wide temperature range"],
    usage: "Pour 60–120ml into tubeless tires every 4–6 months for puncture-free riding.",
    features: ["Tubeless", "1L", "All-Weather", "Pro Workshop"],
    inStock: true
  },
  {
    id: "dynamic-waxifyer-melting-set",
    name: "Dynamic Waxifyer Wax Melting Furnace Set",
    slug: "dynamic-waxifyer-melting-set",
    sku: "EC-PED-041",
    price: 60.00,
    image: "https://images.unsplash.com/photo-1517649763962-0c623066013b?q=80&w=1200&auto=format&fit=crop",
    badge: "Workshop",
    categoryId: "lubricants-care",
    categorySlug: "lubricants-care",
    description: "A complete chain-waxing station: temperature-regulated melting pot, drip tray and hanger. Get pro-team-level drivetrain efficiency at home with safe, mess-free hot waxing.",
    keyBenefits: ["Temp-regulated melt pot", "Drip tray + hanger included", "Pro-team drivetrain prep"],
    usage: "Use for hot-waxing chains at home. Compatible with all paraffin and Silca-style wax blocks.",
    features: ["Melt Pot", "Drip Tray", "Hanger", "Temp Control"],
    inStock: true
  },
  {
    id: "topeak-e-booster-battery-pump",
    name: "Topeak E-Booster Digital Battery Pump",
    slug: "topeak-e-booster-battery-pump",
    sku: "EC-PED-042",
    price: 65.00,
    image: "https://images.unsplash.com/photo-1571333250630-f0230c320b6d?q=80&w=1200&auto=format&fit=crop",
    badge: "Digital",
    categoryId: "pumps-tools-repair",
    categorySlug: "pumps-tools-repair",
    description: "Topeak's E-Booster is a smart digital battery pump with five tire profiles, auto shut-off and 100 PSI output. The OLED screen displays target and live pressure side by side.",
    keyBenefits: ["5 tire profiles", "Auto shut-off", "100 PSI digital"],
    usage: "Set profile, attach to valve and press start. Perfect for road, gravel, MTB and e-bike.",
    features: ["100 PSI", "OLED", "5 Profiles", "Auto Stop"],
    inStock: true
  },
  {
    id: "sram-standard-mineral-oil-bleed-kit",
    name: "SRAM Standard Mineral Oil Bleed Kit",
    slug: "sram-standard-mineral-oil-bleed-kit",
    sku: "EC-PED-043",
    price: 70.00,
    image: "https://www.bike-discount.de/media/96/35/cb/1705519654/squirt-lube-kettenwachs-sl120.jpg",
    badge: "Service",
    categoryId: "pumps-tools-repair",
    categorySlug: "pumps-tools-repair",
    description: "The complete SRAM bleed kit for Maven and DB8 mineral-oil hydraulic brakes. Syringes, fittings and a bottle of factory-fresh mineral oil — everything for a clean bleed.",
    keyBenefits: ["OEM SRAM components", "Mineral oil included", "Compatible with Maven/DB8"],
    usage: "Use for bleeding SRAM mineral-oil hydraulic disc brakes (Maven, DB8 and Code Stealth).",
    features: ["OEM SRAM", "Mineral Oil", "Syringes", "Fittings"],
    inStock: true
  },
  {
    id: "elite-deboyo-thermal-bottle-twin",
    name: "Elite DEBOYO Race Thermal Bottle 550ml — Twin Pack",
    slug: "elite-deboyo-thermal-bottle-twin",
    sku: "EC-PED-044",
    price: 75.00,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HT0JEK6Z8PS7XZTSDHEB1781.avif",
    badge: "Insulated",
    categoryId: "storage-hydration",
    categorySlug: "storage-hydration",
    description: "Elite's DEBOYO Race thermal bottle uses a stainless steel core to hold cold drinks for 5 hours and hot drinks for 2 hours. Twin pack for double-bottle riders.",
    keyBenefits: ["Cold 5h / Hot 2h", "Stainless steel core", "550ml race-shape"],
    usage: "Drop into any standard cage for hot summer training rides and cold-weather coffee runs.",
    features: ["Stainless", "550ml", "Twin Pack", "Race Shape"],
    inStock: true
  },
  {
    id: "sram-pro-mineral-oil-bleeding-kit-v3",
    name: "SRAM Pro Mineral Oil Bleeding Kit V3",
    slug: "sram-pro-mineral-oil-bleeding-kit-v3",
    sku: "EC-PED-045",
    price: 78.00,
    image: "https://images.unsplash.com/photo-1571068316344-75bc76f77890?q=80&w=1200&auto=format&fit=crop",
    badge: "Pro Kit",
    categoryId: "pumps-tools-repair",
    categorySlug: "pumps-tools-repair",
    description: "The Pro V3 kit upgrades the standard bleed kit with reservoir cups, vacuum syringes and pro-grade fittings designed for SRAM's latest mineral-oil hydraulic brake systems.",
    keyBenefits: ["Reservoir cups included", "Vacuum syringes", "Pro-grade fittings"],
    usage: "Workshop-grade kit for full overhaul bleeds of SRAM Maven, Code Stealth and DB8 brakes.",
    features: ["Pro Grade", "Vacuum Syringes", "Reservoir Cups", "Mineral Oil"],
    inStock: true
  },
  {
    id: "sram-standard-dot-bleed-kit-v2",
    name: "SRAM Standard DOT Bleed Kit V2",
    slug: "sram-standard-dot-bleed-kit-v2",
    sku: "EC-PED-046",
    price: 80.00,
    image: "https://images.unsplash.com/photo-1571068316344-75bc76f77890?q=80&w=1200&auto=format&fit=crop",
    badge: "DOT 5.1",
    categoryId: "pumps-tools-repair",
    categorySlug: "pumps-tools-repair",
    description: "The complete SRAM DOT 5.1 bleed kit for Level, Force, Rival and Red AXS hydraulic disc brakes. Includes DOT-rated syringes, fittings, catch bottle and 4oz DOT 5.1 fluid.",
    keyBenefits: ["DOT 5.1 included", "Complete fitting set", "Catch bottle for clean work"],
    usage: "Use to bleed SRAM DOT-fluid hydraulic disc brakes (Level, Force/Rival/Red AXS road).",
    features: ["DOT 5.1", "Syringes", "Catch Bottle", "Fittings"],
    inStock: true
  },
  {
    id: "muc-off-airmach-inflator-pro",
    name: "Muc-Off AirMach Electric Mini Inflator Pro",
    slug: "muc-off-airmach-inflator-pro",
    sku: "EC-PED-047",
    price: 85.00,
    image: "https://www.bike-discount.de/media/6b/1d/00/1705242897/95486.jpg",
    badge: "Smart Pump",
    categoryId: "pumps-tools-repair",
    categorySlug: "pumps-tools-repair",
    description: "Muc-Off's AirMach Pro packs a high-torque motor and twin lithium cells into a pocket-sized inflator. Programmable up to 150 PSI with audible end-pressure alert.",
    keyBenefits: ["150 PSI capable", "Twin lithium cells", "Audible end-pressure alert"],
    usage: "Inflate road, gravel, MTB and e-bike tires anywhere. Doubles as a car-tire emergency pump.",
    features: ["150 PSI", "Twin Cells", "USB-C", "Audible Alert"],
    inStock: true
  },
  {
    id: "silca-chain-waxing-system",
    name: "Silca Chain Waxing System",
    slug: "silca-chain-waxing-system",
    sku: "EC-PED-048",
    price: 90.00,
    image: "https://images.unsplash.com/photo-1571068316344-75bc76f77890?q=80&w=1200&auto=format&fit=crop",
    badge: "Pro System",
    categoryId: "lubricants-care",
    categorySlug: "lubricants-care",
    description: "Silca's integrated waxing system pairs a precision-temp slow cooker with a magnetic chain handle for clean, repeatable hot-waxing at home. Get pro-team drivetrain prep on your bench.",
    keyBenefits: ["Precision temp control", "Magnetic chain handle", "Designed for Secret Blend wax"],
    usage: "Combine with Silca Secret Chain Blend wax for the ultimate low-friction drivetrain at home.",
    features: ["Slow Cooker", "Magnetic Handle", "Temp Control", "Pro Spec"],
    inStock: true
  },
  {
    id: "thule-yepp-nexxt-2-mini-child-seat",
    name: "Thule Yepp Nexxt 2 Mini Child Bike Seat",
    slug: "thule-yepp-nexxt-2-mini-child-seat",
    sku: "EC-PED-049",
    price: 93.00,
    image: "https://images.unsplash.com/photo-1517649763962-0c623066013b?q=80&w=1200&auto=format&fit=crop",
    badge: "Family",
    categoryId: "riding-gear",
    categorySlug: "riding-gear",
    description: "Thule's front-mounted Yepp Nexxt 2 Mini sits your child right between your arms for full visibility and easy chats. UV-protected dual-density shell and integrated harness.",
    keyBenefits: ["Front-mount visibility", "UV-protected shell", "Tool-free install"],
    usage: "Mount on head tube for around-town rides with toddlers 9 months to 3 years.",
    features: ["Front Mount", "UV Shell", "5-Point Harness", "Tool-Free"],
    inStock: true
  },
  {
    id: "pro-race-cycling-jersey",
    name: "Pro Race Cycling Jersey",
    slug: "pro-race-cycling-jersey",
    sku: "EC-PED-050",
    price: 99.00,
    image: "https://images.unsplash.com/photo-1517649763962-0c623066013b?q=80&w=1200&auto=format&fit=crop",
    badge: "Race Fit",
    categoryId: "apparel-clothing",
    categorySlug: "apparel-clothing",
    description: "A pro-cut race jersey with seamless laser-cut sleeves, full-length YKK zipper and three rear pockets. Engineered moisture transfer keeps you dry on the hardest efforts.",
    keyBenefits: ["Laser-cut aero sleeves", "Three rear pockets", "Moisture-wicking fabric"],
    usage: "Road racing, group rides, gran fondos and warm-weather training sessions.",
    features: ["Race Fit", "YKK Zip", "3 Pockets", "Moisture Wicking"],
    inStock: true
  },
  {
    id: "gripgrab-race-aqua-hi-vis-gloves",
    name: "GripGrab Race Aqua Hi-Vis Cycling Gloves",
    slug: "gripgrab-race-aqua-hi-vis-gloves",
    sku: "EC-PED-051",
    price: 100.00,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HTFXFNENCTKEDWSG0DY9NES7.jpg",
    badge: "Hi-Vis",
    categoryId: "apparel-clothing",
    categorySlug: "apparel-clothing",
    description: "Waterproof, windproof and hi-vis. GripGrab's Race Aqua gloves keep your hands warm and dry on cold rainy rides while keeping you visible to traffic.",
    keyBenefits: ["Waterproof + windproof", "Hi-vis fluorescent color", "Touchscreen index finger"],
    usage: "Cold-weather rain riding, autumn commuting and four-season training.",
    features: ["Waterproof", "Hi-Vis", "Touchscreen", "Long Cuff"],
    inStock: true
  },
  {
    id: "pro-bib-shorts-with-chamois",
    name: "Pro Bib Shorts with Chamois Pad",
    slug: "pro-bib-shorts-with-chamois",
    sku: "EC-PED-052",
    price: 101.00,
    image: "https://images.unsplash.com/photo-1571188654248-7a89213915f7?q=80&w=1200&auto=format&fit=crop",
    badge: "Pro Fit",
    categoryId: "apparel-clothing",
    categorySlug: "apparel-clothing",
    description: "Endurance-grade bib shorts built on Italian Lycra with an 8-panel race-fit pattern and a multi-density chamois pad. Comfortable for centuries and long training blocks.",
    keyBenefits: ["8-panel race construction", "Multi-density chamois", "Italian Lycra fabric"],
    usage: "Long road, gravel and indoor training rides where comfort matters most.",
    features: ["8 Panel", "Multi-Density Pad", "Italian Lycra", "Race Fit"],
    inStock: true
  },
  {
    id: "abus-granit-x-plus-u-lock",
    name: "ABUS Granit X-Plus 540 U-Lock",
    slug: "abus-granit-x-plus-u-lock",
    sku: "EC-PED-053",
    price: 105.00,
    image: "https://images.unsplash.com/photo-1571068316344-75bc76f77890?q=80&w=1200&auto=format&fit=crop",
    badge: "Sold Secure Gold",
    categoryId: "safety-visibility",
    categorySlug: "safety-visibility",
    description: "The ABUS Granit X-Plus 540 is one of the highest-rated U-locks on the market. Hardened 13mm steel shackle, parabolic body and X-Plus high-security cylinder.",
    keyBenefits: ["13mm hardened steel", "X-Plus security cylinder", "Sold Secure Gold rated"],
    usage: "High-theft urban areas, transit hubs and overnight outdoor parking.",
    features: ["13mm Steel", "Sold Secure Gold", "Parabolic", "Carry Bracket"],
    inStock: true
  },
  {
    id: "poc-aspire-cycling-sunglasses",
    name: "POC Aspire Cycling Sunglasses",
    slug: "poc-aspire-cycling-sunglasses",
    sku: "EC-PED-054",
    price: 110.00,
    image: "https://images.unsplash.com/photo-1577803645773-f96470509666?q=80&w=1200&auto=format&fit=crop",
    badge: "Optics",
    categoryId: "apparel-clothing",
    categorySlug: "apparel-clothing",
    description: "POC's Aspire glasses deliver a panoramic Carl Zeiss lens for distortion-free vision, with grilamid frame and silicone nose/temple grippers tuned for cycling.",
    keyBenefits: ["Carl Zeiss optics", "Grilamid lightweight frame", "Cycling-specific grippers"],
    usage: "Road, gravel and MTB riding in variable light. Ideal for high-speed descents.",
    features: ["Zeiss Lens", "Grilamid Frame", "Silicone Grips", "Anti-Fog"],
    inStock: true
  },
  {
    id: "garmin-edge-540-bike-gps",
    name: "Garmin Edge 540 Bike GPS Computer",
    slug: "garmin-edge-540-bike-gps",
    sku: "EC-PED-055",
    price: 125.00,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HT0JQNNK3YR2XGYEJYAMF0A9.avif",
    badge: "GPS",
    categoryId: "tech-electronics",
    categorySlug: "tech-electronics",
    description: "The Garmin Edge 540 is a feature-rich GPS bike computer with multi-band GNSS positioning, ClimbPro, training-readiness metrics and full Strava Live Segments support.",
    keyBenefits: ["Multi-band GNSS GPS", "ClimbPro real-time data", "20+ hour battery life"],
    usage: "Daily training, races, gravel adventures and turn-by-turn road navigation.",
    features: ["Multi-Band GNSS", "ClimbPro", "Strava Live", "20h Battery"],
    inStock: true
  },
  {
    id: "alps-alpine-rs1000-ride-safety",
    name: "Alps Alpine RS1000 Ride Safety System",
    slug: "alps-alpine-rs1000-ride-safety",
    sku: "EC-PED-056",
    price: 140.00,
    image: "https://images.unsplash.com/photo-1485965120184-e220f721d03e?q=80&w=1200&auto=format&fit=crop",
    badge: "Connected",
    categoryId: "safety-visibility",
    categorySlug: "safety-visibility",
    description: "A connected front-and-rear lighting system with radar-style proximity alerts, automatic brake light response and a companion app for live ride safety telemetry.",
    keyBenefits: ["Auto brake light response", "Proximity alerts", "Companion app telemetry"],
    usage: "Daily commuting, group rides at dawn/dusk and any traffic-heavy riding environment.",
    features: ["Auto Brake Light", "Proximity Alerts", "App Connected", "USB-C"],
    inStock: true
  },
  {
    id: "karcher-oc-4-bike-cleaner",
    name: "Kärcher OC 4 Mobile Low-Pressure Bike Cleaner",
    slug: "karcher-oc-4-bike-cleaner",
    sku: "EC-PED-057",
    price: 150.00,
    image: "https://www.bike-discount.de/media/12/b9/26/1740944919/karcher-oc-4-bike-kit-15993520-1.jpg",
    badge: "Cordless Wash",
    categoryId: "pumps-tools-repair",
    categorySlug: "pumps-tools-repair",
    description: "The Kärcher OC 4 is a battery-powered, low-pressure mobile bike washer. Built-in 4L water tank, three spray settings and runtime up to 15 minutes per charge.",
    keyBenefits: ["4L tank built-in", "Cordless lithium-ion", "Bike-safe low pressure"],
    usage: "Post-ride wash at the trailhead, race pits, garage and after winter commutes.",
    features: ["4L Tank", "Cordless", "3 Spray Modes", "Bike Safe"],
    inStock: true
  },
  {
    id: "park-tool-pcs-103-repair-stand",
    name: "Park Tool PCS-10.3 Deluxe Home Mechanic Repair Stand",
    slug: "park-tool-pcs-103-repair-stand",
    sku: "EC-PED-058",
    price: 170.00,
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HYBKN670GT3FTXV53KS4Z3Y1.jpg",
    badge: "Pro Stand",
    categoryId: "pumps-tools-repair",
    categorySlug: "pumps-tools-repair",
    description: "The Park Tool PCS-10.3 is the home mechanic's gold-standard repair stand. Cam-actuated clamp holds frames or seatposts up to 80 lbs and folds for clean storage.",
    keyBenefits: ["Holds bikes up to 80 lbs", "360° clamp rotation", "Tool-free folding tripod"],
    usage: "Full home-shop maintenance: drivetrain service, brake bleeds, tune-ups and overhauls.",
    features: ["80 lb Capacity", "360° Clamp", "Folding Tripod", "Pro Spec"],
    inStock: true
  },
  {
    id: "evoc-road-bike-travel-bag-pro",
    name: "Evoc Road Bike Travel Bag Pro",
    slug: "evoc-road-bike-travel-bag-pro",
    sku: "EC-PED-059",
    price: 195.00,
    image: "https://www.bike-discount.de/media/1705524271/b-w-96500-bike-box-2-0-1_for.jpg",
    badge: "Travel",
    categoryId: "storage-hydration",
    categorySlug: "storage-hydration",
    description: "Evoc's Road Bike Bag Pro protects your road or gravel bike during airline travel with reinforced wheel pockets, rigid base plate and integrated rolling chassis.",
    keyBenefits: ["Reinforced wheel pockets", "Rigid base plate", "Rolling chassis"],
    usage: "Airline travel, train transport and storage for road, TT and gravel bikes.",
    features: ["Rolling Chassis", "Rigid Base", "Wheel Pockets", "Pro Travel"],
    inStock: true
  },
];

// ============================================
// CATEGORIES
// ============================================
export const categories = [
  {
    id: "safety-visibility",
    name: "Safety & Visibility",
    slug: "safety-visibility",
    description: "Helmets, mirrors, lights, locks and cameras to keep you safe and seen on every ride",
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HT0KXJKN0YBRXRD4FY53JHNW.avif",
    productCount: 7
  },
  {
    id: "storage-hydration",
    name: "Storage & Hydration",
    slug: "storage-hydration",
    description: "Bottle holders, baskets and storage solutions for long rides and city commutes",
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HYBMCHYQ0E1JN1N1RX82VG9Z.jpg",
    productCount: 6
  },
  {
    id: "pumps-tools-repair",
    name: "Pumps, Tools & Repair",
    slug: "pumps-tools-repair",
    description: "Pumps, multi-tools and repair stands to keep your bike rolling smoothly",
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HS1PB4XZ775CF7R1B9K5F68H.webp",
    productCount: 14
  },
  {
    id: "racks-mounts",
    name: "Racks & Mounts",
    slug: "racks-mounts",
    description: "Wall mounts, hitch racks and storage solutions for home and travel",
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HYBMEMGHJ2KPH7CYFHTGGRF2.jpg",
    productCount: 2
  },
  {
    id: "tech-electronics",
    name: "Tech & Electronics",
    slug: "tech-electronics",
    description: "Smart bike computers, Bluetooth speakers, e-bike kits and cycling tech",
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HT0JX3KXRJ21VJ8KACFW113G.avif",
    productCount: 6
  },
  {
    id: "bikes-components",
    name: "Bikes & Components",
    slug: "bikes-components",
    description: "Complete bicycles, frames, drivetrains and performance components",
    image: "https://images.unsplash.com/photo-1576435728678-68d0fbf94e91?q=80&w=1200&auto=format&fit=crop",
    productCount: 11
  },
  {
    id: "riding-gear",
    name: "Riding Gear",
    slug: "riding-gear",
    description: "Gloves, child seats and rider essentials for every cyclist",
    image: "https://novagen.s3.us-east-2.amazonaws.com/01HTFXFNENCTKEDWSG0DY9NES7.jpg",
    productCount: 3
  },
  {
    id: "lubricants-care",
    name: "Lubricants & Care",
    slug: "lubricants-care",
    description: "Chain wax, sealants, cleaners and hydraulic fluids for pro-grade bike maintenance",
    image: "https://www.bike-discount.de/media/f4/a9/3e/1705525263/silca-secret-chain-blend-hot-wax-kettenwachs-500g-am-ac-016-asy-0100.jpg",
    productCount: 6
  },
  {
    id: "apparel-clothing",
    name: "Apparel & Clothing",
    slug: "apparel-clothing",
    description: "Jerseys, bib shorts, gloves and eyewear engineered for serious cyclists",
    image: "https://images.unsplash.com/photo-1571188654248-7a89213915f7?q=80&w=1200&auto=format&fit=crop",
    productCount: 4
  },
];

// ============================================
// FEATURES / WHY CHOOSE US
// ============================================
export const features = [
  { id: 1, title: 'Curated Bike Gear', description: 'Hand-picked bike accessories tested by everyday cyclists and pros' },
  { id: 2, title: 'Free USA Shipping', description: 'Free USPS Standard Shipping on every order' },
  { id: 3, title: '30-Day Returns', description: 'Easy returns within 30 days, no hassle' },
  { id: 4, title: 'Secure Checkout', description: 'Encrypted payments and protected customer data' }
];

export const performanceBenefits = [
  { id: 1, title: 'Safety-First Designs', description: 'Gear engineered to keep riders safe and visible on every road' },
  { id: 2, title: 'Enhanced Comfort', description: 'Ergonomic accessories that make every ride more enjoyable' },
  { id: 3, title: 'Durable & Reliable', description: 'Built to handle the demands of road, trail and city cycling' },
  { id: 4, title: 'Cyclist-Approved', description: 'Trusted by riders from beginners to seasoned cyclists' }
];

export const steps = [
  { id: 1, title: 'Browse', description: 'Explore our curated lineup of premium bike accessories and gear.' },
  { id: 2, title: 'Pick', description: 'Choose the gadgets and accessories that fit your cycling style.' },
  { id: 3, title: 'Checkout', description: 'Complete your order with secure, encrypted payment.' },
  { id: 4, title: 'Ride', description: 'Unbox, install and ride with confidence on every adventure.' }
];
